// 基础模板
const basicTemplate = {
  id: 'default',
  name: '主界面',
  dataPath: '',
  layout: {
    type: 'NgLayoutGroup',
    props: {},
    children: [
      {
        type: 'NgTopContent',
        componentId: 'NgTopContent0',
      },
    ],
    style: {},
    componentId: 'NgLayoutGroup0',
    class: 'nges-mcm-ui',
  },
  ucVersion: 3,
  styleSheets: [],
  stateSchema: {
    type: 'object',
    fields: [],
  },
  lessCode: '',
};

// 模板1 (全量UI + 两个双行图文)
const template1 = {
  id: 'default',
  name: '主界面',
  dataPath: '',
  layout: {
    type: 'NgLayoutGroup',
    props: {},
    children: [
      {
        type: 'NgTopContent',
        componentId: 'NgTopContent0',
      },
      {
        type: 'NgNavBar',
        componentId: 'NgNavBar0',
        props: {
          $spacing: true,
        },
      },
      {
        type: 'NgSwiperBanner',
        componentId: 'NgSwiperBanner0',
        props: {
          $spacing: true,
        },
      },
      {
        type: 'NgUniversalEntrance',
        componentId: 'NgUniversalEntrance0',
        props: {
          $spacing: true,
        },
      },
      {
        type: 'NgProjectContent',
        componentId: 'NgProjectContent0',
        props: {
          $spacing: true,
        },
      },
      {
        type: 'NgFloatButton',
        componentId: 'NgFloatButton0',
        initedVisible: false, // undefinded/true可见, false不可见
        props: {},
      },
      {
        type: 'NgLayoutGroup',
        componentId: 'NgLayoutGroup2',
        children: [
          {
            type: 'NgTitleBar',
            componentId: 'NgTitleBar0',
            props: {},
          },
          {
            type: 'NgDoubleColImageTextGroup',
            componentId: 'NgDoubleColImageTextGroup0',
          },
        ],
        props: {
          $spacing: true,
          isGroup: true,
        },
      },
      {
        type: 'NgLayoutGroup',
        componentId: 'NgLayoutGroup3',
        children: [
          {
            type: 'NgTitleBar',
            componentId: 'NgTitleBar1',
            props: {},
          },
          {
            type: 'NgDoubleColImageTextGroup',
            componentId: 'NgDoubleColImageTextGroup1',
            props: {},
          },
        ],
        props: {
          isGroup: true,
          $spacing: true,
        },
      },
      {
        type: 'NgLayoutGroup',
        componentId: 'NgLayoutGroup4',
        children: [
          {
            type: 'NgTitleBar',
            componentId: 'NgTitleBar2',
            props: {},
          },
          {
            type: 'NgArticleListGroup',
            componentId: 'NgArticleListGroup0',
            props: {},
          },
        ],
        props: {
          isGroup: true,
        },
      },
    ],
    style: {},
    componentId: 'NgLayoutGroup0',
    class: 'nges-mcm-ui',
  },
  ucVersion: 3,
  styleSheets: [],
  stateSchema: {
    type: 'object',
    fields: [],
  },
};

function CreateMenuTreeList(templateList = [], templateName = '预置模板') {
  const list = [];
  templateList.forEach((item, index) => {
    const id = index + 1;
    const json = JSON.stringify([item]);
    list.push({
      id, // 数字小于100
      name: `${templateName}${id}`,
      path: '/pages/article/template/index',
      json_type: 1, // 可视化编辑
      layout_json: json,
      stable_layout_json: json,
    });
  });
  return list;
}

const localMenuTreeList = CreateMenuTreeList([template1]);

export { basicTemplate, localMenuTreeList, CreateMenuTreeList };
